module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-ivory-002-1200x2490.0d0de36b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-ivory-002-1200x2490.jpg
// module id = 1096
// module chunks = 37